import incomingCall from './Nodes/IncomingCall'
import incomingSms from './Nodes/IncomingSms'
import incomingWebhook from './Nodes/IncomingWebhook'
import contactSubscribed from './Nodes/ContactSubscribed'
import contactTagApplied from './Nodes/ContactTagApplied'
import sayPlay from './Nodes/SayPlay'
import forwardCall from './Nodes/ForwardCall'
import record from './Nodes/Record'
import gather from './Nodes/Gather'
import timeIs from './Nodes/TimeIs'
import dateTimeIs from './Nodes/DateTimeIs'
import dayIs from './Nodes/DayIs'
import callerNumberIs from './Nodes/CallerNumberIs'
import callerStateIs from './Nodes/CallerStateIs'
import callerPostCodeIs from './Nodes/CallerPostCodeIs'
import contactDataIs from './Nodes/ContactDataIs'
import reject from './Nodes/Reject'
import sendAnalyticsEvent from './Nodes/SendAnalyticsEvent'
import sendEmail from './Nodes/SendEmail'
import abSplit from './Nodes/ABSplit'
import pause from './Nodes/Pause'
import sendSmsMessage from './Nodes/SendSmsMessage'
import messageBodyIs from './Nodes/MessageBodyIs'
import huntGroup from './Nodes/HuntGroup'
import portaSayPlay from './Nodes/Porta/PortaSayPlay'
import portaGatherInput from './Nodes/Porta/PortaGatherInput'
import portaForwardCall from './Nodes/Porta/PortaForwardCall'

export const nodes = {
  [sendSmsMessage.id]: sendSmsMessage,
  [incomingSms.id]: incomingSms,
  [incomingCall.id]: incomingCall,
  [incomingWebhook.id]: incomingWebhook,
  [contactSubscribed.id]: contactSubscribed,
  [contactTagApplied.id]: contactTagApplied,
  [forwardCall.id]: forwardCall,
  [sayPlay.id]: sayPlay,
  [record.id]: record,
  [gather.id]: gather,
  [timeIs.id]: timeIs,
  [dateTimeIs.id]: dateTimeIs,
  [dayIs.id]: dayIs,
  [callerStateIs.id]: callerStateIs,
  [callerNumberIs.id]: callerNumberIs,
  [callerPostCodeIs.id]: callerPostCodeIs,
  [contactDataIs.id]: contactDataIs,
  [reject.id]: reject,
  [sendAnalyticsEvent.id]: sendAnalyticsEvent,
  [sendEmail.id]: sendEmail,
  [abSplit.id]: abSplit,
  [pause.id]: pause,
  [messageBodyIs.id]: messageBodyIs,
  [huntGroup.id]: huntGroup,
  [portaSayPlay.id]: portaSayPlay,
  [portaGatherInput.id]: portaGatherInput,
  [portaForwardCall.id]: portaForwardCall,
}

export const nodeExplorer = type => {
  if (type === 'phone_system_incoming_call') {
    return [
      {
        label: 'Triggers',
        nodes: [incomingCall.id],
      },
      {
        label: 'Conditions',
        nodes: [
          contactDataIs.id,
          timeIs.id,
          dateTimeIs.id,
          dayIs.id,
          callerNumberIs.id,
          // callerPostCodeIs.id,
          // callerStateIs.id,
          abSplit.id,
        ],
      },
      {
        label: 'Actions',
        nodes: [
          // forwardCall.id,
          portaForwardCall.id,
          huntGroup.id,
          pause.id,
          // sayPlay.id,
          portaSayPlay.id,
          // record.id,
          // gather.id,
          portaGatherInput.id,
          reject.id,
          sendAnalyticsEvent.id,
          sendEmail.id,
          sendSmsMessage.id,
        ],
      },
    ]
  }
  if (type === 'incoming_call') {
    return [
      {
        label: 'Triggers',
        nodes: [incomingCall.id],
      },
      {
        label: 'Conditions',
        nodes: [
          contactDataIs.id,
          timeIs.id,
          dateTimeIs.id,
          dayIs.id,
          callerNumberIs.id,
          callerPostCodeIs.id,
          callerStateIs.id,
          abSplit.id,
        ],
      },
      {
        label: 'Actions',
        nodes: [
          forwardCall.id,
          pause.id,
          sayPlay.id,
          record.id,
          gather.id,
          reject.id,
          sendAnalyticsEvent.id,
          sendEmail.id,
          sendSmsMessage.id,
        ],
      },
    ]
  }
  return [
    {
      label: 'Triggers',
      nodes: [incomingSms.id, contactSubscribed.id, contactTagApplied.id],
    },
    {
      label: 'Conditions',
      nodes: [messageBodyIs.id, contactDataIs.id, timeIs.id, dateTimeIs.id, dayIs.id, abSplit.id],
    },
    {
      label: 'Actions',
      nodes: [sendEmail.id, sendSmsMessage.id, sendAnalyticsEvent.id],
    },
  ]
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Flow.data.jsx